module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SystemSurveyIndex"
  }, [_c('div', [_c('x-button', {
    ref: "zgTdRef",
    staticStyle: {
      "border": "1px solid #898f02"
    },
    attrs: {
      "gradients": ['#949b02', '#abb220']
    },
    nativeOn: {
      "click": function($event) {
        _vm.jumpToZgTd()
      }
    }
  }, [_vm._v("职工通道")]), _vm._v(" "), _c('x-button', {
    ref: "hzTdRef",
    staticStyle: {
      "border": "1px solid #bf6b02"
    },
    attrs: {
      "gradients": ['#bf6b02', '#ffa12d']
    },
    nativeOn: {
      "click": function($event) {
        _vm.jumpToHzTd()
      }
    }
  }, [_vm._v("患者通道")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32422acf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/ValuationProject/SystemSurveyIndex.vue
// module id = vLXK
// module chunks = 6